'use client'
import { designGrid, font26_24, getP53_2, mq, vw } from '@/styles'
import { useParams } from 'next/navigation'
import styled from 'styled-components'

export const SectionLast = () => {
  const { lang } = useParams()
  return (
    <Section>
      {lang === 'fr' && (
        <>
          <h2>Êtes-vous intéressé par nos produits ?<br/> {`N'hésitez pas à nous contacter !`}</h2>
          <div>
            <h3>FR</h3>
            <p>
              <b>Paris</b>
              <span>3 rue du Chemin Blanc<br/>91160 Champlan<br/>Paris</span>
              <span>Tel. +33 (0) 148 904 750<br/>paris@mammafiore.eu</span>
            </p>
            <p>
              <b>Provence</b>
              <span>Min Des Arnavaux Entrepôt 703B<br/>Avenue Du Marché National<br/>13323 Marseille 14E<br/>Provence</span>
              <span>Tel. +33 (0) 442 590 459<br/>logistic@mammafiore.eu</span>
            </p>
            <p>
              <b>Bordeaux</b>
              <span>110 Quai de Paludate<br/>33800<br/>Bordeaux</span>
              <span>Tel. +33 764 623 795<br/>bordeaux@mammafiore.eu</span>
            </p>
            <p className='nop'>ES</p>
            <p>
              <b>Lyon</b>
              <span>49/51 rue Émile Zola<br/>69150<br/>Décines Charpieu</span>
              <span>Tel. +33 (0) 617 612 574</span>
            </p>
            <p>
              <b>St Tropez</b>
              <span>2 Traverse des Calfats<br/>83990<br/>Saint-Tropez</span>
              <span>Tel. +33 442 590 459</span>
            </p>
            <p>
              <b>Grand Ouest</b>
              <span>7 rue Louis Delage<br/>Zone Billiais Deniaud<br/>44360 Vigneux de Bretagne<br/>Nantes</span>
              <span>Tel. +33 (0) 699 511 250<br/>nantes@mammafiore.eu</span>
            </p>
          </div>
          <div>
            <h3>ES</h3>
            <p>
              <b>Barcelona</b>
              <span>Carrer Número 27, 63<br/>08040 Barcelona <br/>Barcelona</span>
              <span>Tel. +34 933 037 615<br/>ezequiel@v-enology.com</span>
            </p>
            <p>
              <b>Madrid</b>
              <span>
                Pol. Ind. Ntra. Sra. Butarque<br/>Calle Ramón y Cajal 17<br/>28914 Leganés<br/>Madrid
              </span>
              <span>Tel. +34 914 856 444<br/>davide@mammafiore.eu</span>
            </p>
            <p>
              <b>Gran Canaria</b>
              <span>Pol. Ind. Salinetas<br/>Calle Pintor s/n<br/>352219 Telde<br/>Las Palmas</span>
              <span>Tel. +34 928 074 522<br/>roberto.marrone@v-enology.com</span>
            </p>
            <p className='nop'>ES</p>
            <p>
              <b>Valencia</b>
              <span>Pol. Ind. El Oliveral<br/>Calle C, Nave 10<br/>46190 Ribarroja del Turia<br/>Valencia</span>
              <span>Tel. +34 607 222 976<br/>ezequiel@v-enology.com</span>
            </p>
          </div>
          <div>
            <h3>UK</h3>
            <p>
              <b>London</b>
              <span>Unit 31, Perivale Park<br/>Horsenden Lane South, Greenford UB6 7RJ<br/>London</span>
              <span>Tel. +44 (0) 20 3757 6120<br/>london@mammafiore.eu</span>
            </p>
          </div>
          <div>
            <h3>DE</h3>
            <p>
              <b>Berlin</b>
              <span>Bessemerstraße, 80<br/>12103<br/>Berlin</span>
              <span>Tel. +49 302 798 0 249<br/>berlin@mammafiore.eu</span>
            </p>
          </div>
        </>
      )}
      {lang === 'en' && (
        <>
          <h2>Are you interested in our products?<br /> {`Don't`} hesitate to get in touch!</h2>
          <div>
            <h3>UK</h3>
            <p>
              <b>London</b>
              <span>Unit 31, Perivale Park<br />Horsenden Lane South, Greenford UB6 7RJ<br />London</span>
              <span>Tel. +44 (0) 20 3757 6120<br />london@mammafiore.eu</span>
            </p>
          </div>
          <div>
            <h3>ES</h3>
            <p>
              <b>Barcelona</b>
              <span>Carrer Número 27, 63<br />08040 Barcelona <br />Barcelona</span>
              <span>Tel. +34 933 037 615<br />ezequiel@v-enology.com</span>
            </p>
            <p>
              <b>Madrid</b>
              <span>
                Pol. Ind. Ntra. Sra. Butarque<br />Calle Ramón y Cajal 17<br />28914 Leganés<br />Madrid
              </span>
              <span>Tel. +34 914 856 444<br />davide@mammafiore.eu</span>
            </p>
            <p>
              <b>Gran Canaria</b>
              <span>Pol. Ind. Salinetas<br />Calle Pintor s/n<br />352219 Telde<br />Las Palmas</span>
              <span>Tel. +34 928 074 522<br />roberto.marrone@v-enology.com</span>
            </p>
            <p className='nop'>ES</p>
            <p>
              <b>Valencia</b>
              <span>Pol. Ind. El Oliveral<br />Calle C, Nave 10<br />46190 Ribarroja del Turia<br />Valencia</span>
              <span>Tel. +34 607 222 976<br />ezequiel@v-enology.com</span>
            </p>
          </div>
          <div>
            <h3>FR</h3>
            <p>
              <b>Paris</b>
              <span>3 rue du Chemin Blanc<br />91160 Champlan<br />Paris</span>
              <span>Tel. +33 (0) 148 904 750<br />paris@mammafiore.eu</span>
            </p>
            <p>
              <b>Provence</b>
              <span>Min Des Arnavaux Entrepôt 703B<br />Avenue Du Marché National<br />13323 Marseille 14E<br />Provence</span>
              <span>Tel. +33 (0) 442 590 459<br />logistic@mammafiore.eu</span>
            </p>
            <p>
              <b>Bordeaux</b>
              <span>110 Quai de Paludate<br />33800<br />Bordeaux</span>
              <span>Tel. +33 764 623 795<br />bordeaux@mammafiore.eu</span>
            </p>
            <p className='nop'>ES</p>
            <p>
              <b>Lyon</b>
              <span>49/51 rue Émile Zola<br />69150<br />Décines Charpieu</span>
              <span>Tel. +33 (0) 617 612 574</span>
            </p>
            <p>
              <b>St Tropez</b>
              <span>2 Traverse des Calfats<br />83990<br />Saint-Tropez</span>
              <span>Tel. +33 442 590 459</span>
            </p>
            <p>
              <b>Grand Ouest</b>
              <span>7 rue Louis Delage<br />Zone Billiais Deniaud<br />44360 Vigneux de Bretagne<br />Nantes</span>
              <span>Tel. +33 (0) 699 511 250<br />nantes@mammafiore.eu</span>
            </p>
          </div>
          <div>
            <h3>DE</h3>
            <p>
              <b>Berlin</b>
              <span>Bessemerstraße, 80<br />12103<br />Berlin</span>
              <span>Tel. +49 302 798 0 249<br />berlin@mammafiore.eu</span>
            </p>
          </div>
        </>
      )}
      {lang === 'de' && (
        <>
          <h2>Interesse an unseren Produkten?<br /> Wir beraten Sie gerne!</h2>
          <div>
            <h3>DE</h3>
            <p>
              <b>Berlin</b>
              <span>Bessemerstraße, 80<br />12103<br />Berlin</span>
              <span>Tel. +49 302 798 0 249<br />berlin@mammafiore.eu</span>
            </p>
          </div>
          <div>
            <h3>ES</h3>
            <p>
              <b>Barcelona</b>
              <span>Carrer Número 27, 63<br />08040 Barcelona <br />Barcelona</span>
              <span>Tel. +34 933 037 615<br />ezequiel@v-enology.com</span>
            </p>
            <p>
              <b>Madrid</b>
              <span>
                Pol. Ind. Ntra. Sra. Butarque<br />Calle Ramón y Cajal 17<br />28914 Leganés<br />Madrid
              </span>
              <span>Tel. +34 914 856 444<br />davide@mammafiore.eu</span>
            </p>
            <p>
              <b>Gran Canaria</b>
              <span>Pol. Ind. Salinetas<br />Calle Pintor s/n<br />352219 Telde<br />Las Palmas</span>
              <span>Tel. +34 928 074 522<br />roberto.marrone@v-enology.com</span>
            </p>
            <p className='nop'>ES</p>
            <p>
              <b>Valencia</b>
              <span>Pol. Ind. El Oliveral<br />Calle C, Nave 10<br />46190 Ribarroja del Turia<br />Valencia</span>
              <span>Tel. +34 607 222 976<br />ezequiel@v-enology.com</span>
            </p>
          </div>
          <div>
            <h3>FR</h3>
            <p>
              <b>Paris</b>
              <span>3 rue du Chemin Blanc<br />91160 Champlan<br />Paris</span>
              <span>Tel. +33 (0) 148 904 750<br />paris@mammafiore.eu</span>
            </p>
            <p>
              <b>Provence</b>
              <span>Min Des Arnavaux Entrepôt 703B<br />Avenue Du Marché National<br />13323 Marseille 14E<br />Provence</span>
              <span>Tel. +33 (0) 442 590 459<br />logistic@mammafiore.eu</span>
            </p>
            <p>
              <b>Bordeaux</b>
              <span>110 Quai de Paludate<br />33800<br />Bordeaux</span>
              <span>Tel. +33 764 623 795<br />bordeaux@mammafiore.eu</span>
            </p>
            <p className='nop'>ES</p>
            <p>
              <b>Lyon</b>
              <span>49/51 rue Émile Zola<br />69150<br />Décines Charpieu</span>
              <span>Tel. +33 (0) 617 612 574</span>
            </p>
            <p>
              <b>St Tropez</b>
              <span>2 Traverse des Calfats<br />83990<br />Saint-Tropez</span>
              <span>Tel. +33 442 590 459</span>
            </p>
            <p>
              <b>Grand Ouest</b>
              <span>7 rue Louis Delage<br />Zone Billiais Deniaud<br />44360 Vigneux de Bretagne<br />Nantes</span>
              <span>Tel. +33 (0) 699 511 250<br />nantes@mammafiore.eu</span>
            </p>
          </div>
          <div>
            <h3>UK</h3>
            <p>
              <b>London</b>
              <span>Unit 31, Perivale Park<br />Horsenden Lane South, Greenford UB6 7RJ<br />London</span>
              <span>Tel. +44 (0) 20 3757 6120<br />london@mammafiore.eu</span>
            </p>
          </div>
        </>
      )}
      {lang === 'es' && (
        <>
          <h2>¿Estás interesado en nuestros productos?<br /> ¡No dudes en contactarnos!</h2>
          <div>
            <h3>ES</h3>
            <p>
              <b>Barcelona</b>
              <span>Carrer Número 27, 63<br />08040 Barcelona <br />Barcelona</span>
              <span>Tel. +34 933 037 615<br />ezequiel@v-enology.com</span>
            </p>
            <p>
              <b>Madrid</b>
              <span>
                Pol. Ind. Ntra. Sra. Butarque<br />Calle Ramón y Cajal 17<br />28914 Leganés<br />Madrid
              </span>
              <span>Tel. +34 914 856 444<br />davide@mammafiore.eu</span>
            </p>
            <p>
              <b>Gran Canaria</b>
              <span>Pol. Ind. Salinetas<br />Calle Pintor s/n<br />352219 Telde<br />Las Palmas</span>
              <span>Tel. +34 928 074 522<br />roberto.marrone@v-enology.com</span>
            </p>
            <p className='nop'>ES</p>
            <p>
              <b>Valencia</b>
              <span>Pol. Ind. El Oliveral<br />Calle C, Nave 10<br />46190 Ribarroja del Turia<br />Valencia</span>
              <span>Tel. +34 607 222 976<br />ezequiel@v-enology.com</span>
            </p>
          </div>
          <div>
            <h3>FR</h3>
            <p>
              <b>Paris</b>
              <span>3 rue du Chemin Blanc<br />91160 Champlan<br />Paris</span>
              <span>Tel. +33 (0) 148 904 750<br />paris@mammafiore.eu</span>
            </p>
            <p>
              <b>Provence</b>
              <span>Min Des Arnavaux Entrepôt 703B<br />Avenue Du Marché National<br />13323 Marseille 14E<br />Provence</span>
              <span>Tel. +33 (0) 442 590 459<br />logistic@mammafiore.eu</span>
            </p>
            <p>
              <b>Bordeaux</b>
              <span>110 Quai de Paludate<br />33800<br />Bordeaux</span>
              <span>Tel. +33 764 623 795<br />bordeaux@mammafiore.eu</span>
            </p>
            <p className='nop'>ES</p>
            <p>
              <b>Lyon</b>
              <span>49/51 rue Émile Zola<br />69150<br />Décines Charpieu</span>
              <span>Tel. +33 (0) 617 612 574</span>
            </p>
            <p>
              <b>St Tropez</b>
              <span>2 Traverse des Calfats<br />83990<br />Saint-Tropez</span>
              <span>Tel. +33 442 590 459</span>
            </p>
            <p>
              <b>Grand Ouest</b>
              <span>7 rue Louis Delage<br />Zone Billiais Deniaud<br />44360 Vigneux de Bretagne<br />Nantes</span>
              <span>Tel. +33 (0) 699 511 250<br />nantes@mammafiore.eu</span>
            </p>
          </div>
          <div>
            <h3>DE</h3>
            <p>
              <b>Berlin</b>
              <span>Bessemerstraße, 80<br />12103<br />Berlin</span>
              <span>Tel. +49 302 798 0 249<br />berlin@mammafiore.eu</span>
            </p>
          </div>
        </>
      )}
      {lang === 'pt' && (
        <>
          <h2>Se estiver interessado nos nossos produtos, não hesite em contactar-nos!</h2>
          <div>
            <h3>PT</h3>
            <p>
              <b>Sintra</b>
              <span>Avenida Dr. Luís Sá, nº. 9 e 9-A<br />Abrunheira, 2710-089<br />Sintra</span>
              <span>Tel. +351 21 595 26 00<br />info@v-enology.com</span>
            </p>
          </div>
          <div>
            <h3>UK</h3>
            <p>
              <b>London</b>
              <span>Unit 31, Perivale Park<br />Horsenden Lane South, Greenford UB6 7RJ<br />London</span>
              <span>Tel. +44 (0) 20 3757 6120<br />london@mammafiore.eu</span>
            </p>
          </div>
          <div>
            <h3>ES</h3>
            <p>
              <b>Barcelona</b>
              <span>Carrer Número 27, 63<br />08040 Barcelona <br />Barcelona</span>
              <span>Tel. +34 933 037 615<br />info@mammafiore.eu</span>
            </p>
            <p>
              <b>Madrid</b>
              <span>
                Pol. Ind. Ntra. Sra. Butarque<br />Calle Ramón y Cajal 17<br />28914 Leganés<br />Madrid
              </span>
              <span>Tel. +34 914 856 444<br />comercial@mammafioremadrid.eu</span>
            </p>
            <p>
              <b>Gran Canaria</b>
              <span>Pol. Ind. Salinetas<br />Calle Pintor s/n<br />352219 Telde<br />Las Palmas</span>
              <span>Tel. +34 928 074 522<br />canarias@mammafiore.eu</span>
            </p>
            <p className='nop'>ES</p>
            <p>
              <b>Fuerteventura/Lanzarote</b>
              <span>Calle la Serventía s/n<br />35600 Puerto del Rosario<br />Las Palmas</span>
              <span>Tel. +34 928 074 522<br />canarias@mammafiore.eu</span>
            </p>
            <p>
              <b>Tenerife</b>
              <span>Pol. Ind. de Granadilla; Nave 15<br />Parcela Z8-Z9; Sector SP2.02<br />38600 Granadilla de Abona<br />Sta. Cruz de Tenerife</span>
              <span>Tel. +34 656 659 839<br />tenerife@mammafiore.eu</span>
            </p>
            <p>
              <b>Valencia</b>
              <span>Pol. Ind. El Oliveral<br />Calle C, Nave 10<br />46190 Ribarroja del Turia<br />Valencia</span>
              <span>Tel. +34 607 222 976<br />valencia@mammafiore.eu</span>
            </p>
          </div>
          <div>
            <h3>FR</h3>
            <p>
              <b>Paris</b>
              <span>3 rue du Chemin Blanc<br />91160 Champlan<br />Paris</span>
              <span>Tel. +33 (0) 148 904 750<br />paris@mammafiore.eu</span>
            </p>
            <p>
              <b>Provence</b>
              <span>Min Des Arnavaux Entrepôt 703B<br />Avenue Du Marché National<br />13323 Marseille 14E<br />Provence</span>
              <span>Tel. +33 (0) 442 590 459<br />logistic@mammafiore.eu</span>
            </p>
            <p>
              <b>Bordeaux</b>
              <span>110 Quai de Paludate<br />33800<br />Bordeaux</span>
              <span>Tel. +33 764 623 795<br />bordeaux@mammafiore.eu</span>
            </p>
            <p className='nop'>ES</p>
            <p>
              <b>Lyon</b>
              <span>49/51 rue Émile Zola<br />69150<br />Décines Charpieu</span>
              <span>Tel. +33 (0) 617 612 574</span>
            </p>
            <p>
              <b>St Tropez</b>
              <span>2 Traverse des Calfats<br />83990<br />Saint-Tropez</span>
              <span>Tel. +33 442 590 459</span>
            </p>
            <p>
              <b>Grand Ouest</b>
              <span>7 rue Louis Delage<br />Zone Billiais Deniaud<br />44360 Vigneux de Bretagne<br />Nantes</span>
              <span>Tel. +33 (0) 699 511 250<br />nantes@mammafiore.eu</span>
            </p>
          </div>
          <div>
            <h3>DE</h3>
            <p>
              <b>Berlin</b>
              <span>Bessemerstraße, 80<br />12103<br />Berlin</span>
              <span>Tel. +49 302 798 0 249<br />berlin@mammafiore.eu</span>
            </p>
          </div>
        </>
      )}
    </Section>
  )
}


const Section = styled.section`

  h2 {
    ${getP53_2()}
    margin: 0 ${vw(20, 'mobile')} ${vw(70, 'mobile')};

    ${mq.greaterThan('tablet')} {
      margin: 0 ${vw(240, 'desktop')} ${vw(120, 'desktop')};
    }
  }

  div {
    ${designGrid({})}
    padding: 0;
    margin-top: ${vw(60, 'mobile')};

    &:first-child {
      margin-top: 0;
    }

    h4, h3, b {
      ${font26_24(true)}

      ${mq.greaterThan('tablet')} {
        ${font26_24(false)}
      }
    }

    h3 {
      grid-area: 1 / 1 / span 1 / span 1;
      text-align: center;
      font-family: var(--font-basier-circle);
      font-weight: 700;

      ${mq.greaterThan('tablet')} {
        text-align: left;
      }
    }

    p {
      ${mq.lessThan('tablet')} {
        grid-column: 2 / span 5;
        padding: 0 ${vw(20, 'mobile')} 0 ${vw(13, 'mobile')};
      }

      &.nop {
        display: none;
      }
    }

    span {
      font-family: var(--font-basier-circle);
      font-size: ${vw(15, 'mobile')};
      font-weight: 400;
      letter-spacing: -.5px;
      line-height: ${vw(20, 'mobile')};

      ${mq.greaterThan('tablet')} {
        font-size: ${vw(18, 'desktop')};
        line-height: ${vw(25, 'desktop')};
      }
    }

    p {
      font-family: var(--font-basier-circle);
      margin-bottom: ${vw(37, 'mobile')};

      b, span {
        display: block;
        font-family: var(--font-basier-circle);
        margin-bottom: ${vw(15, 'mobile')};

        ${mq.greaterThan('tablet')} {
          margin-bottom: ${vw(15, 'desktop')};
        }
      }

      b {
        font-weight: 700;
      }

    }

    ${mq.greaterThan('tablet')} {
      margin-top: ${vw(60, 'desktop')};

      h3 {
        grid-area: 1 / 2 / span 1 / span 1;
      }

      p {
        grid-column-end: span 3;
        margin-bottom: ${vw(60, 'desktop')};

        &.nop {
          display: block;
          opacity: 0;
          grid-column-end: span 2;
        }
      }
    }
  }
`
